import React, { Component } from 'react';
import { Card, Alert } from 'reactstrap';

class Error extends Component {
    constructor(props) {
        super(props);
        // this.getInitialValue = this.getInitialValue.bind(this);
    }

    render(){
        let error = this.props.message == 'Unknown' ? 'שגיאה! משתמש לא מוכר.' : this.props.message;
        return (
            <Card body className="col-sm-12">
            {/* <div style={{minHeight:'800px'}}> */}
                <Alert style={{marginTop:'15%'}} color="danger">{error}</Alert>
            {/* </div> */}
            </Card>
        );
    }
  };
  
export default Error;